import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { Subject } from 'rxjs';
import { Sgke370dDialogComponent } from '../../components/sgke370d-dialog/sgke370d-dialog.component';
import { Sgke370dDialogData } from '../../models/sgke370d-dialog-data';
import { UsedSgke371aService } from '../../services/used-sgke371a.service';

@Component({
  selector: 'app-sgke370d',
  templateUrl: './sgke370d.component.html',
  styleUrl: './sgke370d.component.scss'
})
export class Sgke370dComponent implements OnInit, OnDestroy {

  /** MatDialog参照 */
  ref: MatDialogRef<Sgke370dDialogComponent, any>;
  /** 購読を停止するためのSubject */
  private onDestroy$ = new Subject();

  data: Sgke370dDialogData = {
    /** 供給地点特定番号 */
    suppntSpno: '100000000000001',
    /** 供給停止再開履歴番号 */
    supplystopresumptionRrkno: '10002',
    /** 供給停止・再開作業種別コード */
    supplystopresumptionWorkClscode: '1',
    /** エネルギー種別コード */
    energyClscode: '1',
    /** 供給停止年月日 */
    supplystopYearmonthdate: '20250101',
    /** 検針タイミング */
    // 供給再開登録のタイミングのため「供給停止時」の固定値
    kenshinTiming: '供給停止時',
    /** 前回メータ番号 */
    preMeterNo: '1000000003',
    /** 前回指針値 */
    preShishin: 101,
    /** 前回メータ型 */
    preMeterModel: '104',
    /** 前回メータ能力 */
    preMeterAbility: 100005,
    /** 前回メータ情報一致フラグ */
    meterInfoIcchiflag: '0',
    /** メータ取替有フラグ */
    meterTorikaeEonflg: '1',
    /** 取外メータ番号 */
    removalMeterNo: '1000667890',
    /** 取外時指針 */
    duringremovalShishin: 1000767890,
    /** 取付メータ番号 */
    installationMeterNo: '1000867890',
    /** 取付時指針 */
    duringinstallationShishin: 1000967890,
    /** メーター回転有無フラグ */
    meterRotationEonflg: '1',
    /** 今回指針値 */
    duringstopShishin: 1001067890,
  }

  /**
   * コンストラクタ
   * @param {UsedSgke371aService} registService
   * @param {MatDialog} dialog
   * @memberof Sgke370dComponent
   */
  constructor(
    public registService: UsedSgke371aService,
    private dialog: MatDialog,
  ) {
  }

  /**
   * 初期処理
   * @memberof Sgke370dComponent
   */
  ngOnInit(): void {
  }

  /**
   * 購読解除
   * @memberof Sgke370dComponent
   */
  ngOnDestroy() {
    //購読を停止する処理
    this.onDestroy$.next();
  }

  /**
   * 指針入力ボタン押下時処理
   *
   * @memberof Sgke370dComponent
   */
  public onClickShishinBtn(): void {

    ;

    // ダイアログオープン
    this.ref = this.dialog.open(Sgke370dDialogComponent, {
      height: '910px',
      width: '1150px',
      disableClose: true,
      data: this.data,
    });

    // クローズ時の処理
    this.ref.afterClosed().subscribe(result => {
      // 表示するためのコンテナを取得
      const targetContainer = document.getElementById('target-container');
      targetContainer ? targetContainer.innerHTML = '' : null;
      // 各項目をpタグに変換
      for (const key in result) {
        if (result.hasOwnProperty(key)) {
          const p = document.createElement('p');
          p.textContent = `${key}: ${result[key]}`;
          targetContainer.appendChild(p);
        }
      }
    });
  }


}
